import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import OrderedListOutlinedSvg from "@ant-design/icons-svg/es/asn/OrderedListOutlined";
import AntdIcon from "../components/AntdIcon";
var OrderedListOutlined = function OrderedListOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: OrderedListOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  OrderedListOutlined.displayName = 'OrderedListOutlined';
}
export default /*#__PURE__*/React.forwardRef(OrderedListOutlined);